export const selectOFTemplates = (state) => state.outputForms.templates